import { api } from "../..";
import { ApiConfig } from "../../ApiConfig";

const baseURL = ApiConfig.baseApi;

const getHeaders = () => {
  const token = localStorage.getItem("accessToken");
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };
};

const buildUrl = (path = "") => `${baseURL}${ApiConfig.subscription}${path}`;

const subscriptionService = {
  list: async ({ page = 1, limit = 10, search = "", filterBy = "" } = {}) => {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (limit) params.append("limit", limit);
    if (search) {
      params.append("search", search);
    }
    if (filterBy) {
      params.append("filterBy", filterBy);
    }

    const queryString = params.toString();
    const url = `${buildUrl()}${queryString ? `?${queryString}` : ""}`;
    return api.get(url, null, getHeaders());
  },

  getById: async (id) => {
    const url = buildUrl(`/${id}`);
    return api.get(url, null, getHeaders());
  },

  create: async (payload) => {
    const url = buildUrl();
    return api.post(url, payload, getHeaders());
  },

  update: async (id, payload) => {
    const url = buildUrl(`/${id}`);
    return api.put(url, payload, getHeaders());
  },

  blockByAdmin: async (adminId, payload) => {
    const url = buildUrl(`/admin/${adminId}/block`);
    return api.put(url, payload, getHeaders());
  },

  delete: async (id) => {
    const url = buildUrl(`/${id}`);
    return api.delete(url, undefined, getHeaders());
  },

  deleteByAdmin: async (adminId) => {
    const url = `${baseURL}admin-delete/${adminId}`;
    return api.delete(url, undefined, getHeaders());
  },

  updateCompany: async (id, payload) => {
    const url = `${baseURL}company?id=${id}`;
    return api.put(url, payload, getHeaders());
  },

  updateAdmin: async (adminId, payload) => {
    const url = `${baseURL}admin-update/${adminId}`;
    return api.put(url, payload, getHeaders());
  },

  summary: async () => {
    const url = `${baseURL}${ApiConfig.subscriptionSummary}`;
    return api.get(url, null, getHeaders());
  },

  // Self-service upgrade/downgrade. companyId is derived from the JWT server-
  // side. Response drives the UI: changeType, paymentRequired, proration,
  // paymentBreakdown, limitViolations (DOWNGRADE_BLOCKED), authorizationUrl.
  managePlan: async (payload) => {
    const url = buildUrl("/manage-plan");
    return api.post(url, payload, getHeaders());
  },

  // Outstanding-balance status: { message, isDisabledForNonPayment, ... }.
  outstandingStatus: async () => {
    const url = buildUrl("/outstanding-status");
    return api.get(url, null, getHeaders());
  },

  // Toggle autopay on/off. { enabled: boolean }.
  autopay: async (payload) => {
    const url = buildUrl("/autopay");
    return api.post(url, payload, getHeaders());
  },

  export: async () => {
    const url = buildUrl("/export");
    return api.get(url, null, getHeaders(), "blob");
  },

  verifyPayment: async (reference) => {
    const url = buildUrl(`/payment/verify/${reference}`);
    return api.get(url, null, getHeaders());
  },

  // Regional Analytics Stats API with filters
  stats: async (filters = {}) => {
    const params = new URLSearchParams();

    // Add filter parameters if provided
    if (filters.country) params.append("country", filters.country);
    if (filters.region) params.append("region", filters.region);
    if (filters.package || filters.planId) {
      params.append("package", filters.package || filters.planId);
    }
    if (filters.currency) params.append("currency", filters.currency);

    const queryString = params.toString();
    const url = `${baseURL}${ApiConfig.subscriptionSummary}${queryString ? `?${queryString}` : ""}`;
    return api.get(url, null, getHeaders());
  },
};

export default subscriptionService;
